import React, { useEffect, useState } from "react";
import money from "../../../assets/img/icons/money-4.svg";
import rate from "../../../assets/img/icons/star.svg";
import CountBox from "../../dropbox/CountBox";
import mines from "../../../assets/img/icons/Vector.svg";
import add from "../../../assets/img/icons/add.svg";
import arrow from "../../../assets/img/icons/arrow-left 2.svg";
import IconBox from "../../shared/IconBox";
import Button from "../../shared/Button";
import DateBoxModal from "../../dropbox/DateBoxModal";
import { DateObject } from "react-multi-date-picker";
import { toast } from "react-hot-toast";
import useFetch from "../../../hooks/useAxios";
import { useNavigate, useParams } from "react-router-dom";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import gregorian_en from "react-date-object/locales/gregorian_en";
import PersianNumber from "../../shared/PersianNumber";
import { useUserInfo } from "../../../context/UserContext";
const PlaceCostinfo = ({ inforesidencedetail ,selectedDay,setSelectedDay}) => {
  const [count, setCount] = useState(0);
  const [costinNight, setCostinNight] = useState(0);
  const [costperExtra, setcostperExtra] = useState(0);
  const [start, setStart] = useState(false);
  const [errorcount, seterrorcount] = useState("");
  const [end, setEnd] = useState(false);
  const [extra, setExtra] = useState(0);
  const [selectedEndDay, setSelectedEndDay] = useState(null);
  const {code,slug}=useParams()
 const navigate = useNavigate("")
 const [isProfileCompeleted, setisProfileCompeleted] = useState(); //city //start //end //count
 const isProfileCompletedFetch = useFetch({
   method: "get",
   url: "api/complete-profile",
   noHeader: false,
   trigger: true,
   argFunc: res => setisProfileCompeleted(res.data.is_complete)
 });
  const apiGetresidencedetailInfo = useFetch({
    method: "post",
    url: `api/guest/reserve/${code}`,
    noHeader: false,
    trigger: false,
    data:{
      ppcount:count,
      entrance_date:selectedDay ? new DateObject(selectedDay[0]).convert(persian, gregorian_en).format("YYYY-MM-DD") :null,
      leaving_date:selectedDay ?new DateObject(selectedDay[selectedDay.length - 1]).convert(persian, gregorian_en).format("YYYY-MM-DD") : null
    },
    argFunc:(res)=>{
      toast.success(res.message)
      (inforesidencedetail.instant_reserve === 1 ? navigate(`/checkout/payments/${slug}/${code}/${res.data.id}`):navigate(`/checkout/${slug}/${code}/${res.data.id}`))
    
    },
    errMessage:(err)=>{
      if(err.response.data.message){
        toast.error(err.response.data.message)
      }
     
    }
    
   
  });
  const increase = () => {
    if(count >= inforesidencedetail.max_capacity ){
     seterrorcount("تعداد مهمان ها نباید بزرگتر از حداکثر مجاز باشد.")
    }else{
      seterrorcount("")
      setCount(prev => (prev += 1));
    }
   
  };
  const decrease = () => {
    if (count > 0) {
      seterrorcount("")
      setCount(prev => (prev -= 1));
    }
  };
  const closeStartModal = () => {
    setStart(false);
  };
  if(selectedDay){
      (new DateObject(selectedDay[selectedDay.length - 1].format("YYYY-MM-DD")))
  }
 useEffect(() => {
  if(count > inforesidencedetail.capacity){
    setExtra( count -inforesidencedetail.capacity)
  }
 }, [count])
 useEffect(() => {
   if(selectedDay){
     setcostperExtra((selectedDay?.length - 1 )* extra * inforesidencedetail.per_extra_person)
   }
  
 }, [selectedDay,extra])
 const {userinfo} = useUserInfo()
 const gotoreserve = () =>{
    if(userinfo.data.user.role === "مهمان"){
 

      if(isProfileCompeleted){
        apiGetresidencedetailInfo.reFetch()
      }else{
        toast.error("برای رزرو اقامتگاه لطفا اول پروفایل خود را کامل کنید.")
        navigate("/user/editprofile")
      }
    }else{
      apiGetresidencedetailInfo.reFetch()
    }
 }
 function round(value, precision) {
  var multiplier = Math.pow(10, precision || 0);
  return Math.round(value * multiplier) / multiplier;
}
  return (
    <div className="PlaceCostinfo py-[30px] px-[20px]">
      <div className=" border-b-[1px] border-b-[solid] border-b-[#eaeaea] pb-[20px] mb-[38px]">
        <div className="flex items-center mb-[8px]">
          <img className="ml-[6px]" src={money} />
          <p className="text-[#12171C] text-[18px] font-[500]">قیمت هر شب :</p>
        </div>
        <div className="flex justify-between items-center">
          <p className=" ">
            <span className="text-[#00A6A6] Danafont text-[32px] font-[600]">
             <PersianNumber number={inforesidencedetail.price} />
            </span>
            <span className="text-[#797D82] mb-[10px] text-[22px] font-[500]">
              تــومان
            </span>
          </p>
          <div className="flex items-center">
            <p className="text-[#12171C] text-[18px] font-[900] ml-[5px]">
         <PersianNumber number={round(inforesidencedetail.rating_value,1)}/>
            </p>
            <img src={rate} />
          </div>
        </div>
      </div>
      <div className="CountBox__container datebox__container flex justify-between items-center" onClick={()=>setStart(true)}>
        <button
          onClick={() => {
            setStart(true);
          }}
        >
        {selectedDay
            ? <p>
             
              { new DateObject(selectedDay[0]).format("YYYY-MM-DD")} 
              </p>
            : <p>تاریخ رفت</p>}  
        </button>
        <div className="countbox-iconbox">
          <img src={arrow} />
        </div>
        <button
          onClick={() => {
            setEnd(true);
          }}
        >
      {selectedDay
            ? <p>
               {new DateObject(selectedDay[selectedDay.length - 1]).format("YYYY-MM-DD")} 
              </p>
            : <p>تاریخ برگشت</p>}
        </button>
      </div>
      <div className="CountBox__container flex justify-between items-center">
        <IconBox onClick={increase} white className="CountBox__iconbox">
          <img width={24} src={add} />
        </IconBox>
        <p>
         <PersianNumber  number={count} />نفر
        </p>
        <IconBox onClick={decrease} white className="CountBox__iconbox">
          <img width={12} src={mines} />
        </IconBox>
      </div>
      <div className="red-text">{errorcount}</div>
      <Button varient="secondary" fullwidth disabled={count === 0 || selectedDay === null} onClick={()=>gotoreserve()}>
        درخواست رزرو اقامتگاه
      </Button>
      <div className="center">
      <p className="mt-[12px] text-[#797D82] text-[13px] font-[400] mx-auto">ارسال درخواست رزرو برای شما هزینه‌ای ندارد!</p>

      </div>
   {(selectedDay !== null && count !== 0 )&& <div>
    <div className="d-flex-space PlaceCostinfo-cost row mt-[14px]">
        <p >
        {selectedDay ? selectedDay?.length - 1 : 0} شب اقامت
        </p>
        <div className="PlaceCostinfo--p"><PersianNumber number={costinNight} /></div>

      </div>
      <hr className="my-[14px]"/>
      <div className="d-flex-space  PlaceCostinfo-cost ">
        <p>
        {extra}  مهمان اضافه
        </p>
        <div className="PlaceCostinfo--p"><PersianNumber number={costperExtra}/></div>

      </div>
      <hr className="my-[14px]"/>

      <div className="d-flex-space  PlaceCostinfo-final-cost ">
        <p>
        جمع مبلغ قابل پرداخت
        </p>
        <div><PersianNumber number={costinNight + costperExtra}/></div>
      </div>
    </div>}
      {start &&
       
        
          <DateBoxModal
            setSelectedDay={setSelectedDay}
            inforesidencedetail={inforesidencedetail}
            selectedDay={selectedDay}
            closeModal={() => setStart(false)}
            costinNight={costinNight}
            setCostinNight={setCostinNight}
          />
        }
    
    </div>
  );
};

export default PlaceCostinfo;
